import React from "react";
import { observer } from "mobx-react";
import { Avatar, Button, createStyles, Divider, makeStyles, Theme, Typography } from "@material-ui/core";
import { ContentSave } from "mdi-material-ui";
import { getSearchLink } from "../../Navigation/Links";
import { useNavigateInternally } from "../../Navigation/Hooks";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        prompt: {
            marginBottom: theme.spacing(1),
            maxWidth: 800,
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        avatar: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            width: '75px',
            height: '75px',
            margin: '16px auto'
        },
        divider: {
            width: '90%',
            margin: '30px auto',
        },
        title: {
            maxWidth: 700,
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: theme.spacing(2),
        },
    })
);

interface PreferenceSavedProps {
    organizationName: string;
    acceptedNotifications?: boolean;
}

const PreferenceSaved = observer((props: PreferenceSavedProps) => {

    /********* React hooks *********/

    const classes = useStyles();
    const navigate = useNavigateInternally();

    /********* Event handler *********/

    const onButtonClicked = () => {
        navigate(getSearchLink());
    }

    /***** Render *****/

    return (
        <React.Fragment>
            <Avatar className={classes.avatar}>
                <ContentSave fontSize='large' />
            </Avatar>
            <Typography variant="h4" className={classes.prompt}>
                Your notification preferences have been saved.
            </Typography>
            <Typography>
                {props.acceptedNotifications
                    ? `You're signed up to receive notifications regarding this volunteer's involvement at ${props.organizationName}.`
                    : `You won't receive further emails regarding this volunteer's involvement at ${props.organizationName}.`
                }
            </Typography>
            <Divider className={classes.divider} />
            <Typography variant="h5" className={classes.title}>
                {props.acceptedNotifications
                    ? `Interested in volunteering yourself?`
                    : `Interested in volunteering?`
                }
            </Typography>
            <Button
                variant="contained"
                color='primary'
                onClick={onButtonClicked}
            >
                Browse Opportunities
            </Button>
        </React.Fragment>
    );
});

export default PreferenceSaved;